module.exports = function isShallowEqual (a, b) {
  if (a === b) return true
  for (var i in a) if (!(i in b)) return false
  for (var i in b) if (a[i] !== b[i]) return false
  return true
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/is-shallow-equal/index.js
// module id = 1150
// module chunks = 0